<script setup lang="ts">
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';
  defineProps<{ canSettings: boolean }>();
  const emit = defineEmits<{ (event: 'configure'): void }>();
  const benefits = [
    { key: 'benefitOnline', icon: 'web' },
    { key: 'benefitReminders', icon: 'bell-check-outline' },
    { key: 'benefitFloor', icon: 'floor-plan' },
  ];
</script>

<template>
  <section class="reservations-hero">
    <div class="hero-icon">
      <PosUiIcon name="calendar-check-outline" :size="36" />
    </div>
    <h2>{{ $t('reservations.hero.title') }}</h2>
    <p class="hero-description">{{ $t('reservations.hero.description') }}</p>
    <div class="hero-benefits">
      <div v-for="benefit in benefits" :key="benefit.key" class="benefit">
        <PosUiIcon :name="benefit.icon" :size="24" />
        <span>{{ $t(`reservations.hero.${benefit.key}`) }}</span>
      </div>
    </div>
    <PosUiButton
      v-if="canSettings"
      size="lg"
      icon="cog-outline"
      @click="emit('configure')"
    >
      {{ $t('reservations.hero.cta') }}
    </PosUiButton>
    <p v-else class="ask-admin">{{ $t('reservations.hero.askAdmin') }}</p>
  </section>
</template>

<style scoped lang="scss">
  .reservations-hero {
    @apply tw-mx-auto tw-flex tw-max-w-4xl tw-flex-col tw-items-center tw-px-5 tw-py-10 tw-text-center md:tw-py-16;
    .hero-icon {
      @apply tw-mb-5 tw-flex tw-h-20 tw-w-20 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-neutral-200 tw-text-neutral-600;
    }
    h2 {
      @apply tw-mb-3 tw-text-2xl tw-font-semibold tw-tracking-tight tw-text-neutral-900 md:tw-text-3xl;
    }
    .hero-description {
      @apply tw-m-0 tw-max-w-xl tw-text-base tw-leading-relaxed tw-text-neutral-500;
    }
    .hero-benefits {
      @apply tw-my-8 tw-grid tw-w-full tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-3;
    }
    .benefit {
      @apply tw-flex tw-items-center tw-rounded-xl tw-border tw-border-solid tw-border-neutral-200 tw-bg-white tw-p-4 tw-text-left tw-text-sm tw-font-medium tw-text-neutral-700;
      > span {
        @apply tw-ml-3;
      }
    }
    .ask-admin {
      @apply tw-m-0 tw-text-sm tw-text-neutral-500;
    }
  }
</style>
